import React, { useState } from 'react';
import { Form, Input, InputNumber, Popconfirm, Table, Button, Typography, Flex } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';

const originData = [
    {
      key: '0',
      clave: 'audio.path',
      value:'https://rtvc.ycs.es/audios/',
    },
    {
      key: '1',
      clave: 'categories',
      value:'Tertulia; Actualidad; Noticias; Música; Actualidad internacional; Deportes',
    },
    {
      key: '2',
      clave: 'acceso_externo',
      value:'true',
    },
    {
      key: '3',
      clave: 'permitir_descarga',
      value:'false',
    },
  ];

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};


/**
 * Component Configuracion
 * @returns 
 */
export const Configuracion = () => {
  const [form] = Form.useForm();
  const [data, setData] = useState(originData);
  const [editingKey, setEditingKey] = useState('');
  const isEditing = record => record.key === editingKey;
  const edit = record => {
    form.setFieldsValue({ clave: '', value: '', ...record });
    setEditingKey(record.key);
  };
  const cancel = () => {
    setEditingKey('');
  };
  const save = async key => {
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex(item => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setData(newData);
        setEditingKey('');
      } else {
        newData.push(row);
        setData(newData);
        setEditingKey('');
      }
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };

  const [count, setCount] = useState(2);
  const handleDelete = key => {
    const newData = data.filter(item => item.key !== key);
    setData(newData);
  };
  const columns = [
    {
      title: '',
      dataIndex: 'operation',
      width: '7%',
      render: (_, record) =>{
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link onClick={() => save(record.key)} style={{ marginInlineEnd: 8 }}>
              Save
            </Typography.Link>
            <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
              <a>Cancel</a>
            </Popconfirm>
          </span>
        ) : (
          <Flex gap="small" wrap>
            <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
              <Button variant='solid' color="orange" shape="circle" icon={<EditOutlined />} size='middle' />
            </Typography.Link>
            <Popconfirm title="¿Está seguro?" onConfirm={() => handleDelete(record.key)}>
              <Button type="primary" danger shape="circle" icon={<DeleteOutlined />} size='middle' />
            </Popconfirm>
          </Flex>
          
        );
      },
    },
    {
      title: 'Clave',
      dataIndex: 'clave',
      editable: true,
    },
    {
      title: 'Valor',
      dataIndex: 'value',
      editable: true,
    },
    
  ];
  const handleAdd = () => {
    const newData = {
      key: count,
      clave: ``,
      value:``,
    };
    setData([...data, newData]);
    setCount(count + 1);
  };

 const mergedColumns = columns.map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: record => ({
        record,
        inputType: 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  return (
    <div>
      <Button onClick={handleAdd} type="primary" style={{ marginBottom: 16 }}>
        Agregar Clave
      </Button>
      <Form form={form} component={false}>
        <Table
          components={{
            body: { cell: EditableCell },
          }}
          rowClassName={'editable-row'}
          bordered
          dataSource={data}
          columns={mergedColumns}
        />
      </Form>
    </div>
  );
};